export type Fonts = 'Archivo' | 'Archivo Narrow'

export type FontWeight = '400' | '600' | '700' | '800' | '900'
export type FontStyle = 'normal' | 'italic'

export const FontWeights: Record<string, FontWeight> = {
  REGULAR: '400',
  SEMIBOLD: '600',
  BOLD: '700',
  XBOLD: '800',
  BLACK: '900',
}

export const PRIMARY_FONT: Fonts = 'Archivo'
export const SECONDARY_FONT: Fonts = 'Archivo Narrow'
